import cloneDeep from 'lodash.clonedeep';
import types from './actionTypes';
// import handlers from '../../../test/handlers'



const initialState = []

export default function appReducer(state = initialState, action) {
    switch (action.type) {

        case types.ADD_LUAFILES: {
            return [
                ...state,
                action.payload
            ]
        }

        case types.EDIT_LUAFILES: {
            return state.map(luaFile => {
                if (luaFile.clusterlet == action.payload.clusterlet && luaFile.event === action.payload.event && luaFile.type === action.payload.type) {
                    return { ...luaFile, data: action.payload.data, clusterlet: action.payload.clusterlet }
                } else {
                    return { ...luaFile }
                }
            })
        }

        case types.DELETE_LUAFILES: {
            return state.filter(luaCode => luaCode.id !== action.payload.id)
        }

        case types.UPDATE_FULL_HANDLERS: {
            return [
                ...state,
                ...action.payload
            ]
        }

        case types.RESET_HANDLERS: {
            return [
                ...action.payload
            ]
        }

        case 'RESET_BLUEPRINT':
            return cloneDeep(initialState);

        default:
            return state;
    }
}